export default function(datetime) {
    if(datetime === null)
    return null;
    
    var hh = datetime.getHours();
    var mm = datetime.getMinutes();

    return (hh > 9 ? '' : '0') + hh + ':' + (mm > 9 ? '' : '0') + mm;
}
